import {
  Card,
  IconButton,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import { CircularProgress } from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import HistoryIcon from "@mui/icons-material/History";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import moment from "moment";
import componentStyles from "assets/theme/views";
import MaskAndValid from "utils/maskAndValid";

const useStyles = makeStyles({
  ...componentStyles,
  th: {
    color: "#32325d",
    fontSize: ".75rem",
    fontFamily: "inherit",
    fontWeight: 600,
    lineHeight: 1.5,
    textAlign: "center",
    padding: "15px 8px",
  },
  td: {
    fontSize: ".75rem",
    fontFamily: "inherit",
    fontWeight: 500,
    textAlign: "center",
    padding: "10px 8px",
    whiteSpace: "normal",
    wordBreak: "break-word",
  },
});

function formatBrl(value) {
  const num = Number(value) || 0;
  return num.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export default function TableSolicitacoes({
  lista,
  setPage,
  totalPages,
  onEdit,
  onViewHistorico,
  onResendEmail,
  resendingId,
}) {
  const classes = useStyles();

  return (
    <Card>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell className={classes.th}>Cód. ERP</TableCell>
              <TableCell className={classes.th}>CNPJ</TableCell>
              <TableCell className={classes.th}>Razão Social</TableCell>
              <TableCell className={classes.th}>Data Solicitação</TableCell>
              <TableCell className={classes.th}>Nº Nota</TableCell>
              <TableCell className={classes.th}>Valor Total</TableCell>
              <TableCell className={classes.th}>Status</TableCell>
              <TableCell className={classes.th}>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {lista.map((row) => (
              <TableRow key={row.IdSolicitacaoDevolucaoInterna}>
                <TableCell className={classes.td}>
                  {row.CodigoErpCliente || "-"}
                </TableCell>
                <TableCell className={classes.td}>
                  {MaskAndValid.maskCNPJ(row.CnpjCliente || "") ||
                    row.CnpjCliente}
                </TableCell>
                <TableCell className={classes.td}>{row.RazaoSocial}</TableCell>
                <TableCell className={classes.td}>
                  {moment(row.DataSolicitacao).format("DD/MM/YYYY")}
                </TableCell>
                <TableCell className={classes.td}>{row.NumeroNota}</TableCell>
                <TableCell className={classes.td}>
                  {formatBrl(row.ValorTotalNota)}
                </TableCell>
                <TableCell className={classes.td}>{row.Status}</TableCell>
                <TableCell className={classes.td}>
                  <Tooltip title="Gerenciar solicitação (protocolo, notas e documentos)">
                    <IconButton size="small" onClick={() => onEdit(row)}>
                      <AssignmentIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Histórico de alterações">
                    <IconButton
                      size="small"
                      onClick={() => onViewHistorico(row)}
                    >
                      <HistoryIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  {!row.EmailCrcEnviado && (
                    <Tooltip title="Reenviar e-mail ao CRC (envio anterior falhou)">
                      <span>
                        <IconButton
                          size="small"
                          onClick={() => onResendEmail(row)}
                          disabled={
                            resendingId === row.IdSolicitacaoDevolucaoInterna
                          }
                        >
                          {resendingId ===
                          row.IdSolicitacaoDevolucaoInterna ? (
                            <CircularProgress size={16} />
                          ) : (
                            <ForwardToInboxIcon fontSize="small" />
                          )}
                        </IconButton>
                      </span>
                    </Tooltip>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {totalPages > 1 && (
        <Pagination
          count={totalPages}
          onChange={(_, value) => setPage(value)}
          style={{ display: "flex", justifyContent: "center", padding: "1rem" }}
        />
      )}
    </Card>
  );
}
